/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

import { Filter, FilterValue } from "@Internal/Contracts";
import { CustomValue, SelectionFilter } from "@Internal/Models";

let defaultFilters: Filter[] = [];

function getStates(): FilterValue[] {
    return [
        new CustomValue<string>( $t( "CONSOLE_USERS_stateActive" ), "active" ),
        new CustomValue<string>( $t( "CONSOLE_USERS_statePending" ), "pending" ),
        new CustomValue<string>( $t( "CONSOLE_USERS_stateDisabled" ), "disabled" )
    ];
}

function Get(): Filter[] {
    if( defaultFilters.length === 0 )
        defaultFilters = [
            new SelectionFilter(
                "State",
                $t( "CONSOLE_USERS_filterState" ),
                getStates(),
                $t( "CONSOLE_USERS_filterStatePlaceholder" )
            )
        ];

    return defaultFilters;
}

export default {
    Get
};
